if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeUpdateCartNote.ajaxCart', note);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    // alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

ShopifyAPI.checkMaxquantity = function(variantID, Quantity) {
  //alert(variantID);
  var item1;
  var cart_count;
  $.ajax({
    url:'/cart.js', 
    dataType : 'json',
    async : false,
    success : function(cart) {
      // now have access to Shopify cart object
      //console.log(cart);
      cart_count = cart.item_count;
      cart.items.forEach(function(item){
        if(item.id == variantID)
          item1 = item;
      });
      // alert(item1.quantity);
    } 
  });
 
    if(cart_count > 0){  
   
    if(item1 && item1.quantity){
      console.log(item1);
       if(item1.hasOwnProperty('properties') && item1.properties!=null && item1.properties.hasOwnProperty('shipping_interval_frequency'))
    {
         
         var totalCount = parseInt(Quantity)+parseInt(item1.quantity); 

      if(totalCount <= 2){
        var responce={status:true,subscription:1} ;      
        return responce;      
      }else{
         var responce={status:false,subscription:1};
         return responce;
      }
    
    } else{
     
      var totalCount = parseInt(Quantity)+parseInt(item1.quantity); 
      if(totalCount <= 10){
         var responce={status:true,subscription:0};
        return responce;      
      }else{
        var responce={status:false,subscription:0};
         return responce;
      }      
    }
  }
       
  else{
    var responce={status:true,subscription:0};
   return responce; 
  }
    }
    
  
  else{
    var responce={status:true,subscription:0};
   return responce; 
  }
  //return false;
};
ShopifyAPI.checkFreequantity = function(variantID,SampleArray) {
  //alert(variantID);
  var item1;
  var freeStatus;
  var cart_count;
  $.ajax({
    url:'/cart.js', 
    dataType : 'json',
    async : false,
    success : function(cart) {
      // now have access to Shopify cart object
      console.log(cart);
      cart_count = cart.item_count;
      cart.items.forEach(function(item){
        
        if(item.price == 0 && jQuery.inArray(item.variant_id, SampleArray) !== -1)
          freeStatus = 1;
      });
      // alert(item1.quantity);
    } 
  });
  if(freeStatus == 1){ 
    return false;
  }

  //return false;
};
ShopifyAPI.updateCartitemQuantity = function() {
  //alert(variantID);
  var item1;
  var cart_count;
  $.ajax({
    url:'/cart.js', 
    dataType : 'json',
    async : false,
    success : function(cart) {
      cart_count = cart.item_count;
      $('#cartCount').html(cart_count).removeClass('hidden-count');
      $('.mobile-cart-count').html(cart_count).removeClass('hidden-count');
      $('#cartCount_floating').html(cart_count).removeClass('hidden-count');
    } 
  });
};
ShopifyAPI.checkOtherproducts = function() {
  //alert(variantID);
  var item1;
  var enableCheck;
  var cart_count;
  $.ajax({
    url:'/cart.js', 
    dataType : 'json',
    async : false,
    success : function(cart) {
      // now have access to Shopify cart object
     
      cart_count = cart.item_count;
      cart.items.forEach(function(item){
        
        if(item.price > 0)
          enableCheck = 1;
      });
      // alert(item1.quantity);
    } 
  });
  if(enableCheck == 1){ 
    return true;
  }else{
   return false;
  }
 
  //return false;
};
ShopifyAPI.checkonlyoneFreeproduct = function() {
  //alert(variantID);
  var item1;
  var enableCheck1 = 0;
  var enableCheck2 = 0;
  var cart_count;
  $.ajax({
    url:'/cart.js', 
    dataType : 'json',
    async : false,
    success : function(cart) {
      // now have access to Shopify cart object
     
      cart_count = cart.item_count;
      cart.items.forEach(function(item){
        
        if(item.price == 0){
          enableCheck1 = 1;
        }
        if(item.price > 0){
          enableCheck2 = 1;
        }
      });
      // alert(item1.quantity);
    } 
  });
  if(enableCheck1 == 1 && enableCheck2 == 0){
    return false;
  }else{
   return true;
  }
  //return false;
};
ShopifyAPI.clearCart = function() {
  
   $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      success: function(){
        //location.reload();
      },
      dataType: 'json'
    });

};
/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  if($('.errors').length){
    $('.errors').remove();
  }
  
  var variantIdnew;
  var quantity ;
  var purchase_type;
  var dataArray = $(form).serializeArray();
  //console.log(dataArray);
  jQuery.each( dataArray, function( i, field ) { 
    //alert(field.name);
    if(field.name == 'id'){
    	variantIdnew = field.value;    
    }    
        if(field.name == 'quantity'){
    	 quantity = field.value;    
    } 
    if(field.name == 'purchase_type'){
    	 purchase_type = field.value;    
    }
  });
 
  var selectedVal = $("#productSelect option:selected").val();
  var Quantity =  $("#qunatityInput").val(); 
  if(Quantity == undefined || Quantity == ''){
    Quantity = 1;
  }
   var responceData = ShopifyAPI.checkMaxquantity(variantIdnew,Quantity);
 
  console.log(responceData);
  var Status = responceData.status;
  var subscription=responceData.subscription;
  if(purchase_type == 'autodeliver' && quantity > 2)
  {
    Status=false;
    subscription='1';
  }
   if(Status == false && Status != undefined && subscription == '1'){
    $('#quantitySusbscriptionLimitReached').show();
    $(form).find('.quantitySusbscriptionLimitReached').show();

   return;
  }else{
   $('#quantitySusbscriptionLimitReached').hide();
   $(form).find('.quantitySusbscriptionLimitReached').hide();

  }
  
  if(Status == false && Status != undefined){
    $('#quantityLimitReached').show();
    $(form).find('.quantityLimitReached').show();

   return;
  }else{
   $('#quantityLimitReached').hide();
   $(form).find('.quantityLimitReached').hide();

  }
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    beforeSend: function(jqxhr, settings) {
      $body.trigger('beforeAddItem.ajaxCart', form);
      $('#AddToCartText').text("...");
       $(form).find('.Addtocart-text').text("...");
      $(form).find('#AddToCartTextGT').text("...");
      $(form).find('.addtocart-text-bottom').text("...");
      $(form).find('.addtocart-text-pretties').text("...");
       $(form).find('.plp-btn-text').text("...");
      $(form).find('.plp-btn-price').hide();
       $(form).find('#buttonPrice').hide();

    },
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
      $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
      if(('#quickshopClose').length){
         //$( "#quickshopClose" ).trigger( "click" );
         //ajaxCart.load();
       }
       $('#AddToCartText').text("Added");
       $(form).find('#AddToCartTextGT').text("Added");
       $(form).find('.addtocart-text-bottom').text("Added");
       $(form).find('.Addtocart-text').text("Added");
       $(form).find('.addtocart-text-pretties').text("Added");
       $(form).find('.plp-btn-text').text("Added");
   
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
      event: "add_to_cart",
      ecommerce: {     
      value: line_item.final_line_price / 100,
      currency: ShoplocalCurrency,
      items: [
        {
          id: line_item.product_id,
          name: line_item.product_title,
          brand: line_item.vendor,          
          item_list_name: line_item.product_type,
          item_list_id: line_item.product_type,
          price: line_item.final_line_price / 100,
          variant: line_item.variant_title,
          quantity:line_item.quantity
        }]
      }
  });console.log('DATA' , line_item);


       setTimeout(function(){ 
         $('#AddToCartText').text("Add to cart"); 
         $(form).find('.Addtocart-text').text("Add to bag");
         var PText = $(form).find('.lp_grouped_btn').data("text");
         $(form).find('.addtocart-text-pretties').text(PText);  
           $(form).find('.plp-btn-text').text("ADD TO BAG");
           $(form).find('.plp-btn-price').show();
           $(form).find('#buttonPrice').show();
         
       }, 2000);
       setTimeout(function(){ $(form).find('#AddToCartTextGT').text("ADD TO BAG"); }, 2000);
       setTimeout(function(){ 
        if($('#GlowTonicLanding').length){
         $(form).find('.addtocart-text-bottom').text("Add to bag");
        }else{
         $(form).find('.addtocart-text-bottom').text("Add to cart");
        }
                                   
      }, 2000);


    },
    error: function(XMLHttpRequest, textStatus) {
      $(form).find('.Addtocart-text').text("Add to bag");
      $(form).find('.plp-btn-text').text("ADD TO BAG");
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus, $(form));
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) { //console.log(line);
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};


// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItemmax = function(variantID, quantity, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&id=' + variantID,
    dataType: 'json',
    async:false,
    beforeSend: function() {
     // $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      //$body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};
/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride,samplePackAdd,prettiesPackAdd, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty,updatethessSlider,updatetheExpressButtons, setViewScroll, deviceDetect, checkoutDOMChange, checkDOMChange,checkQunatitylimit,updateQuantitymax,addTocartUpsell,updateNoticeText;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : '#cartCount',
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart ) {
      formOverride();
    }
     samplePackAdd();
    prettiesPackAdd();
    addTocartUpsell();
    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');
      $('.mobile-cart-count').html(cart.item_count).removeClass('hidden-count');
      $('#cartCount_floating').html(cart.item_count).removeClass('hidden-count');
      parent.$('#cartCount').html(cart.item_count).removeClass('hidden-count');
      parent.$('.mobile-cart-count').html(cart.item_count).removeClass('hidden-count');
      parent.$('#cartCount_floating').html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
        $('.mobile-cart-count').addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
    $('#AddToCartForm1,#AddToCartForm2').on('submit', function(evt) {
        evt.preventDefault(); 
         ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
    $('.collection-bottom-products form[action^="/cart/add"]').on('submit', function(evt) {
        evt.preventDefault(); 
         ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
    $('.quick-add-row  form[action^="/cart/add"]').on('submit', function(evt) {
        evt.preventDefault(); 
         ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
     $('.pretties-grouped-wrapper form[action^="/cart/add"]').on('submit', function(evt) {
        evt.preventDefault(); 
         ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
    $('.hydrating-wrapper form[action^="/cart/add"]').on('submit', function(evt) {
        evt.preventDefault(); 
         ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
    $('.eye-patches form[action^="/cart/add"]').on('submit', function(evt) {
        evt.preventDefault(); 
         ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
    $('body').on('submit', '.collection-add-to-cart', function (evt) {
       $(this).find('.plp-addtoCart').addClass('added');
        evt.preventDefault(); 
        ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
		});
     $(document).on("click",".ajax_cart__checkout",function(event) {
       var CheckoutStatus = ShopifyAPI.checkOtherproducts();
       if(CheckoutStatus == false && CheckoutStatus != undefined){       
          event.preventDefault();
       }
     });
  };
    updateNoticeText = function (cart) {
   var price = (cart.total_price)/100;
   var shippingPrice =document.querySelector("#shipping_price").value;
   var shippintText = document.querySelector("#shipping_text").value;
     if(price >= shippingPrice )
     {
       document.querySelector("#notice_text").innerText ="Congratulations! You've got free shipping";
     }
     else if(price == 0){
        document.querySelector("#notice_text").innerText = shippintText + ' ' +''+ shippingPrice;
     }
     else{
       document.querySelector("#notice_text").innerText = "Only " + '£' +(shippingPrice-price)+ ' away from free shipping ';
     }
  
  };
   prettiesPackAdd = function () {
     $(document).on("click","#prettiesAlladd",function() { 
       $(this).text('...');
       var arrayVal = $(this).data('ids');
       var newArray = new Array();
       var product;
          Shopify.queue = [];
            var quantity = 1 ;
            newArray = arrayVal.toString().split(',');
            for (var i = 0; i < newArray.length; i++) {
              product = newArray[i]
              Shopify.queue.push({
                variantId: product,
              });
                }
            Shopify.moveAlong = function() {
            // If we still have requests in the queue, let's process the next one.
            if (Shopify.queue.length) {
              var request = Shopify.queue.shift();
              var data = 'id='+ request.variantId + '&quantity=1'
              $.ajax({
                type: 'POST',
                    url: '/cart/add.js',
                dataType: 'json',
                data: data,
                success: function(res){
                  Shopify.moveAlong();
                quantity += 1;
               },
               error: function(error){ 
               // if it's not last one Move Along else update the cart number with the current quantity
                if (Shopify.queue.length){
                  Shopify.moveAlong()
                } else {
                  //$('#cart-number').replaceWith("<a href="/cart" id="cart-number">View cart (" + quantity + ")</a>")
                }
                }
                 });
              }
           // If the queue is empty, we add 1 to cart
          else {
            quantity += 1;           
            ajaxCart.load();
            $("#prettiesAlladd").text('ADD ALL TO BAG');
           }
             };
          Shopify.moveAlong();
     });
   };
   samplePackAdd = function () {
      var clickStatus = false;
     $(document).on("click",".sample-products ul li:not(.added)",function() {
       var sample_product_array = [];
        if( $('.sample-wrapper').length){
          $('.sample-wrapper ul li').each(function() {
            sample_product_array.push($(this).data("id"));   
          });
       } 
       var variant_id = $(this).attr("data-id");
       var data_comapre_price = $(this).attr("data-comapre-price");
       var FreeExist = ShopifyAPI.checkFreequantity(variant_id,sample_product_array);
       if(FreeExist == false && FreeExist != undefined){
         return;
       }
       $(this).find('.loader').fadeIn();
       if(clickStatus == false){
          clickStatus = true;
       jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
              quantity: 1,
              id: variant_id,
               properties: {
                 'Original Price': data_comapre_price,
                 'free_sample' :true
               }
          },
          dataType: 'json',           
          success: function(data) {
            console.log(data);
            ajaxCart.load();
            //$(this).find('.loader').fadeOut();
            //$(this).addClass("added");
            clickStatus = false;
          },
          error: function() {
           clickStatus = false;
          }     
       });   
     }
     });
  };
 

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');
    $(".plp-addtoCart").removeClass('added');

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus,$this) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $this.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {  
    // Update quantity and price
    if (cart.item_count >0) {  
      var cartlimitStaus;
      $.each(cart.items, function(index, cartItem) {      
         if(cartItem.quantity>5){
           cartlimitStaus = 1;  
           updateQuantitymax(cartItem.id,5);
        } 
      });
    }  
    
    updateCountPrice(cart);
    buildCart(cart);
    updateNoticeText(cart);


    
  };
   addTocartUpsell = function () {
   $(document).on("click",".custom_upsell_addtocart",function() { 
    event.preventDefault();
 
    jQuery(".upsell_custom.loader").css("display","block");
    var upsellId =  window.upsellId; 
    
    var variant= window.variant ;
    jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
        quantity: 1,
        id: variant,
       
    },
    dataType: 'json',           
    success: function(data) {
     
      ajaxCart.load();
      
      jQuery(".upsell_custom.loader").css("display","none");
      jQuery(upsellId).css("display","none"); 
      //event.preventDefault();
       
    },
    error: function(xhr, textStatus, error) {
     jQuery(".upsell_custom.loader").css("display","none");
     jQuery(upsellId).css("display","none");      
      console.log(error);
    }     
 }); 
  
    });
  };


  buildCart = function (cart) {
    $(document).ready(function() {
		if(window.Nosto){Nosto.reloadCart(["nosto-minicart"]);}
     var Items= cart.items;
     var currency =cart.currency;
     var price = (cart.total_price)/100;
     var handles = [];
     var variant = '';
     for(var i=0;i<Items.length;i++){
         handles.push(Items[i].handle);
     }

     if ((handles.includes("glow-tonic-100ml-1") || handles.includes("glow-tonic-100ml")) && (!handles.includes("glow-tonic-250-ml") && !handles.includes("glow-tonic-250ml") )) {
        jQuery("#glow-tonic-250ml_tab").css("display","grid");
        window.upsellId="#glow-tonic-250ml_tab";
        window.variant = jQuery(".glow-tonic-250ml_variant").attr('data-offerid');
    } else if( (handles.includes("glow-tonic-250ml") ||handles.includes("glow-tonic-250ml-1") ) && !handles.includes("beautifeye")) {
      window.jQuery("#beautifeye_tab").css("display","grid");
        window.upsellId="#beautifeye_tab";
        window.variant = jQuery(".beautifeye_variant").attr('data-offerid');    
    } else if( (price < 35 && currency =='GBP' ) && !handles.includes("vitamin-c-sheet-mask") ) {
      if(!handles.includes("vitamin-c-sheet-mask")){
        jQuery("#vitamin-c-sheet-mask_tab").css("display","grid");
        window.upsellId="#vitamin-c-sheet-mask_tab"; 
        window.variant = jQuery(".vitamin-c-sheet-mask_variant").attr('data-offerid');
        }
    } else if( !handles.includes("c-vit-undereye-brightener") ) {
        jQuery("#c-vit-undereye-brightener_tab").css("display","grid");
        window.upsellId="#c-vit-undereye-brightener_tab";
        window.variant = jQuery(".c-vit-undereye-brightener_variant").attr('data-offerid');
    }

    });
    // Start with a fresh cart div
    $cartContainer.empty();
    timber.RightDrawer.open();
    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
        .append('<div class="drawer__header"><div class="drawer__title h3">Your Cart</div><p class="cart-empty">Your cart is currently empty.</p><div class="drawer__close"><button type="button" class="icon-fallback-text"><span class="icon icon-x" aria-hidden="true"></span><span class="fallback-text">Close</span></button></div></div>');
      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);
    var limitStaus;

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {
      
      
      if(cartItem.quantity>10){ limitStaus = 1;
        //updateQuantitymax(cartItem.id,10);
      }

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_large$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

     if (cartItem.selling_plan_allocation && cartItem.selling_plan_allocation.selling_plan && cartItem.selling_plan_allocation.selling_plan.name) {
   var deliveryIntervalvalue = cartItem.selling_plan_allocation.selling_plan.name;
       console.log( item.deliveryInterval);
  } else {
    
  var  deliveryIntervalvalue = null;
       console.log(item.deliveryInterval);
  }
      
      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        item_id:cartItem.id,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        realPrice:cartItem.price,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
        originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        discountedPrice: Shopify.formatMoney(
          cartItem.final_line_price,
          settings.moneyFormat
        ),
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true,
        deliveryInterval:deliveryIntervalvalue
      };

      items.push(item);
  //    if (cartItem.selling_plan_allocation && cartItem.selling_plan_allocation.selling_plan && cartItem.selling_plan_allocation.selling_plan.name) {
  //   item.deliveryInterval = cartItem.selling_plan_allocation.selling_plan.name;
  //      console.log( item.deliveryInterval);
  // } else {
    
  //   item.deliveryInterval = null;
  //      console.log(item.deliveryInterval);
  // }
    });
    
       

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      totalPricewithoutcurrency: cart.total_price,
      totalCartDiscount: cart.total_discount === 0 ? 0 : "Translation missing: en.cart.general.savings_html".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true
    }

    $cartContainer.append(template(data));

    cartCallback(cart,data.totalPrice);
    
    var sample_product_array = [];
        if( $('.sample-wrapper').length){
            $('.sample-wrapper ul li').each(function() {
              sample_product_array.push($(this).data("id"));   
            });
        } 
        var current = 0;
        var CheckStatus = 0;
        var enableCheck1 = 0;
        var enableCheck2 = 0;
        //var sample_product_array = [31495123763271,31496266022983,31496345026631];
        var freeCartarray = [];
        $.each(cart.items, function(index, cartItem) {      
          $(".sample-products li[data-id='"+cartItem.variant_id+"']").addClass('added');
          
          if(cartItem.price == 0  && jQuery.inArray(cartItem.variant_id, sample_product_array) !== -1){
             current++;
             freeCartarray.push(index);
          }
          if(cartItem.price > 0){
             CheckStatus = 1;        
          }
           if(cartItem.price == 0){
          	enableCheck1 = 1;
          }
          if(cartItem.price > 0){
            enableCheck2 = 1;
          }
        
      
        });
          if(current >= 1){
           $('.sample-wrapper').hide();
          }else{
           $('.sample-wrapper').show();
          }
         if(CheckStatus == 0){
             $('.ajaxcart__footer').addClass('disabled');
          }
          if(enableCheck1 == 1 && enableCheck2 == 0){
            ShopifyAPI.clearCart();
            ajaxCart.load();
          }
          if(current > 1){
                $('.ajaxcart__footer').hide();
                if(freeCartarray.length){
                  jQuery.each( freeCartarray, function( i, val ) {
                    if(i != 0){
                      ShopifyAPI.changeItem(val, 0, adjustCartCallback);
                    }    
                  });
                }
              } 
  };
 var isEventSent = false;
  cartCallback = function(cart,total) {
    
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);

    //timber.RightDrawer.open();
    if(total != '' && total != undefined){
    	var cartTotal = total.replace(/[^\d\.]/g, '');
    }
    updatethessSlider(cartTotal);  
    updatetheExpressButtons();
    setViewScroll();
    deviceDetect();
    checkDOMChange();
    checkoutDOMChange();
    $('#cartCount_drawer').html( "("+ cart.item_count +") ITEMS");
    if($(".subscription_data").length){
       $('.klarna-message').hide();
       $('.ajax_cart__checkout').hide();
       $('.subscription_ajax_cart_checkout').show();
       $('.express__checkout').hide();
       setTimeout(function() { 
         setViewScroll();
       }, 1000);
    }
    $('.offer-text').hide();
      setTimeout(function() { 
        $('body').addClass('drawer-loaded');

    }, 3000);
    
     window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
       window.KlarnaOnsiteService.push({
    eventName: 'refresh-placements'
  });
  $(document).on("click",".drawer__close button",function() {
    timber.RightDrawer.close();
    isEventSent = false;
  });
    
    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
    
    if(total != '' && total != undefined){
      if (!isEventSent) {    
          var lineItems = cart.items;
         dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
          event: "view_cart", 
          ecommerce: {
            value:cart.total_price / 100,
            currency:cart.currency,
            items:lineItems.map(function(item) {
                return {
                  item_id: item.variant_id,
                  item_name: item.title,
                  item_list_name: item.product_type,
                  item_list_id:item.product_type,
                  price: item.price / 100,
                  quantity: item.quantity
                };
              })
            }
          });
          isEventSent = true;   
      }
    }    
  };

  deviceDetect = function(){
   	if(navigator.userAgent.match(/(iPod|iPhone)/)){
      	//alert('IOS found');
  		$('body').addClass('bodyScrollBlock1');
  	 
    }else{
    	//console.log('other OS found');
    }
    $('.drawer__close').click(function(){
    	$('body').removeClass('bodyScrollBlock1');
    })
  };

  
  updatethessSlider = function (cartamt) {

          var c_percent = Math.floor(100* cartamt/35);
          if (c_percent>100){
                      $('.freeship-slider').show();
                      $('#lessFreeshipping').hide();
                      $('.freeshipText').show();
            $('.pricebar-value').css({
                  'width': '100%'
              });
          }else{
              $('.freeship-slider').show();
              $('.pricebar-value').css({
                  'width': ''+c_percent+'%'
              });
            $('#freeshipText').hide(100);
          }  
        var sliderPrice = 35 - cartamt;
        $('#sliderAmt').html(sliderPrice.toFixed(2));


  };
  
  updatetheExpressButtons = function (cartamt) {
    
     if(/iPhone|iPad|iPod/i.test(navigator.userAgent)){
          // show apple pay only
        //$('.gpay-ico').hide();
    }else if (navigator.appVersion.indexOf("Mac")!=-1){
      //console.log('mac os');
      // show apple pay ony
      // $('.gpay-ico').hide();
    }

    else{
     //
      $('.applepay-ico').hide();
    }   
  };
  
  
  setViewScroll = function(){
  	  var v_ht = $(window).height();
      if($('.overflowControl').length){
          var topheight = $('.drawer__header').height() + $('.price-freeship').height();
          var footertop = $(".ajaxcart__footer").offset().top;
          var scrollerTop = $(".overflowControl").offset().top;   	
          var cfooter_ht = $('.ajaxcart__footer').height();
          var ifheight = footertop - scrollerTop;

          $('.overflowControl').css({
            'max-height': ifheight
          });
          $('.nano-content').css({
            'max-height': ifheight
          });	
      	}
    
      checkDOMChange= function(){
         if($(".nudge-wrapper").length == 0){
            setTimeout(checkDOMChange, 500 );
        }else{
          	//$('.nudge-wrapper .product-title').html($('.nudge-wrapper .product-title').html().replace(":", ""));
          	$( ".offer-text" ).insertAfter( ".product-title-wrapper" );
            $('.upsell-title').fadeIn();
             $('.upsellBox-wrapper-uk').addClass('upsellBox-present');
        } 
      
      }
      
      checkoutDOMChange = function(){
        
       if($(".additional_checkout_buttons .shopify-cleanslate ._1M9S34W-UyhhDRRQQiV3RH").length == 0){
             setTimeout(checkDOMChange, 2000 );
        }else{
              if(/iPhone|iPad|iPod/i.test(navigator.userAgent)){
        	    $('.additional_checkout_buttons .shopify-cleanslate ._1M9S34W-UyhhDRRQQiV3RH').attr('style', 'display: none !important');      
       		 }
        } 
      
      }
    
    $(window).resize(function(){
    	if($('.overflowControl').length){
          var topheight = $('.drawer__header').height() + $('.price-freeship').height();
          var footertop = $(".ajaxcart__footer").offset().top;
          var scrollerTop = $(".overflowControl").offset().top;   	
          var cfooter_ht = $('.ajaxcart__footer').height();
          var ifheight = footertop - scrollerTop;

          $('.overflowControl').css({
            'max-height': ifheight
          });
          $('.nano-content').css({
            'max-height': ifheight
          });	
      	}
      
    });
    
     /* $(window).resize(function(){
        v_ht = $(window).height();
        topheight = $('.drawer__header').height() + $('.price-freeship').height();

        footertop = $(".ajaxcart__footer").offset().top;
        scrollerTop = $(".overflowControl").offset().top;
       
        cfooter_ht = $('.ajaxcart__footer').height();
         
        ifheight = footertop - scrollerTop;

        $('.overflowControl').css({
          'max-height': ifheight
        });
        $('.nano-content').css({
          'max-height': ifheight
        });
     }); */
    
    $('.express__checkout').click(function(){
    	cfooter_ht = $('.ajaxcart__footer').height();
      	topheight = $('.drawer__header').height() + $('.price-freeship').height();

        footertop = $(".ajaxcart__footer").offset().top;
        scrollerTop = $(".overflowControl").offset().top;
       
        cfooter_ht = $('.ajaxcart__footer').height();
         
        ifheight = footertop - scrollerTop - 50;

        $('.overflowControl').css({
          'max-height': ifheight
        });
        $('.nano-content').css({
          'max-height': ifheight
        });
    
    
    })
 
} // view scroll ends
  
  checkQunatitylimit = function(qty){
  
    if(qty == 5 || qty > 5 ){
      return ;
    }
  
  }
 
  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }
      var dataMax = $(this).data('max');
      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);
      
      if ($el.hasClass('ajaxcart__qty--plus')) {
        if(qty == 5 || qty > 5 ){
          return ;
        }
        if(dataMax == 1 && dataMax != undefined){
         return ;
        }
        if(qty == dataMax || qty > dataMax ){	
          return ;	
        }
        
      }
      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      
      
      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });
    
     
    //remove from cart
        $("#CartDrawer").on('click', '.remove_cart', function() {
          var $el = $(this),
          line = $el.data('line');      
          updateQuantity(line, 0);
          var itemName = $el.data('item-name');
          var itemId = $el.data('item-id');
          var itemQty = $el.data('item-qty');
          var itemPrice = $el.data('item-price');
          dataLayer.push({ ecommerce: null });
          dataLayer.push({
            event: "remove_from_cart",
            ecommerce: {
              currency: ShoplocalCurrency,
              value: itemPrice,
              items: [
              { 
                item_id: itemId, 
                item_name: itemName, 
                price: itemPrice,
                quantity: itemQty
              }
              ]
            }
          });      
        });

       $(document).on('click', '.cart-count-trigger,.mobile_cart_link', function(event) {
           event.preventDefault();
           ajaxCart.load();
        });
   
    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);
       if(qty > 5 ){
          return ;
        }

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) { 
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }
    
     updateQuantitymax = function(variantID, qty) { 
      isUpdating = true;
      // Slight delay to make sure removed animation is done 
        ShopifyAPI.changeItemmax(variantID, qty, adjustCartCallback);
 
    };

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      isUpdating = false;
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));